import { capabilities } from "@/mocks/capabilities";

export default function WhatWeDo() {
  return (
    <section
      id="what-we-do"
      className="w-full bg-background-100 py-10 md:py-12 lg:py-14"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-8 md:mb-10">
          <p className="text-xs font-semibold tracking-widest uppercase text-primary-600 mb-4">
            Our Capabilities
          </p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            What We Do
          </h2>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {capabilities.map((cap) => (
            <div
              key={cap.id}
              className="group bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-7 hover:border-primary-300/60 transition-colors"
            >
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-100 text-primary-600 shrink-0">
                  <i className={`${cap.icon} text-lg`} />
                </div>
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-xs font-bold text-primary-500">
                      {cap.id}
                    </span>
                    <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-950">
                      {cap.title}
                    </h3>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mt-1">
                    {cap.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}